import { render } from "./AdminTasksLink.vue?vue&type=template&id=4fd54ef5"
import script from "./AdminTasksLink.vue?vue&type=script&lang=js"
export * from "./AdminTasksLink.vue?vue&type=script&lang=js"

import "./AdminTasksLink.vue?vue&type=style&index=0&id=4fd54ef5&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__